import React, { useEffect, useState } from 'react';
import Card from './components/Card';
import { Modal } from 'src/components';
import Button from 'src/components/button';
import { Formik } from 'formik';
import { Form, useNavigate } from 'react-router-dom';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {
  showModal?: boolean;
  handleModal: () => void;
  singleReceiptData?: any;
}

const RefundModal: React.FC<IProps> = ({
  showModal,
  singleReceiptData,
  handleModal,
}) => {
  const navigate = useNavigate();
  const [errorMsgPost, setErrorMsgPost] = React.useState('');

  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [highlightSelected, setHighlightSelected] = useState<any>([]);
  const handleItemClicked = (item: any) => {
    // if (selectedItems.includes(item?.itemName)) {
    //   setSelectedItems((prev: any) => {
    //     const updatedItems = prev.filter(
    //       (selectedItem: any) => selectedItem !== item?.itemName
    //     );
    //     return updatedItems;
    //   });

    if (highlightSelected.includes(item?.id)) {
      setHighlightSelected((prev: any) => {
        const updatedItems = prev.filter(
          (selectedItem: any) => selectedItem !== item?.id
        );
        return updatedItems;
      });

      setSelectedItems((prev: any) => {
        const updatedItems = prev.filter(
          (selectedItem: any) => selectedItem !== item?.id
        );
        return updatedItems;
      });
    } else {
      setSelectedItems((prev: any) => [...prev, item?.id]);
      setHighlightSelected((prev: any) => [...prev, item?.id]);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      receiptId: singleReceiptData[0]?.id,
      customerId: '',
      email: '',
      receiptItemIds: selectedItems,
      receiptComboIds: [],
    };
    try {
      await Service.post('/payments/refund', payload);
      toastAlert('success', `Receipt is successfully refunded`);
      navigate('/receipt');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };
  return (
    <>
      {showModal && (
        <Modal title="Refund" onClick={handleModal}>
          <p className="text-center text-warning text-sm">{errorMsgPost}</p>
          <div className="">
            <div title="" className="mt-6">
              {singleReceiptData[0] &&
                singleReceiptData[0].items.map((item: any) => {
                  return (
                    <div
                      key={item.itemId}
                      className={`${
                        highlightSelected.includes(item?.id)
                          ? 'border-[2px] rounded-xl border-primary cursor-pointer'
                          : ''
                      }cursor-pointer mt-5 pb-2 border border-border-color-dark  rounded-xl`}
                      onClick={() => handleItemClicked(item)}
                    >
                      <p className=" pr-4  pt-2  flex justify-end text-warning  ">
                        {item?.isRefunded && item?.isRefunded === true
                          ? 'Refunded'
                          : ''}
                      </p>
                      <div className="flex justify-between py-2 px-4">
                        <p className="font-semibold text-base capitalize">
                          {item.itemName}
                        </p>
                        <p className="text-base font-normal">{item.price}</p>
                      </div>
                      {item.modifiers.map((modifier: any) => {
                        return (
                          <div key={modifier.id}>
                            <ul>
                              {/* <p className="text-sm pl-4">
                                Modifiers
                              </p> */}
                              {modifier.options.map((option: any) => {
                                return (
                                  <li key={option.id}>
                                    <div className="flex  leading-[5px]  text-sm justify-between py-2 px-4 text-[#949CC0]">
                                      <p>{option.name}</p>
                                      <p>{option.price}</p>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="flex items-center justify-end mt-10">
            <Button
              text="submit"
              variant="primary"
              onClick={selectedItems.length ? handleSubmit : () => {}}
              disabled={!selectedItems.length}
              type="submit"
            ></Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default RefundModal;
